import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BusyLabel } from '../components/Spinner'

interface Props {
  placeholder: string
  onCreate: (name: string) => Promise<void>
  onDone: () => void
}

/** "+" in the panel header: an inline name field; Enter creates, Esc cancels. */
export function NewRow({ placeholder, onCreate, onDone }: Props) {
  const { t } = useTranslation('library')
  const [name, setName] = useState('')
  const [busy, setBusy] = useState(false)
  const submit = async () => {
    const trimmed = name.trim()
    if (!trimmed || busy) return
    setBusy(true)
    try {
      await onCreate(trimmed)
      onDone()
    } finally {
      setBusy(false)
    }
  }
  return (
    <div className="lib-newrow">
      <input
        autoFocus
        className="lib-newrow-input"
        aria-label={placeholder}
        placeholder={placeholder}
        value={name}
        disabled={busy}
        onChange={(e) => setName(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') void submit()
          if (e.key === 'Escape') onDone()
        }}
        onBlur={() => !name.trim() && onDone()}
      />
      <span className="lib-newrow-hint"><BusyLabel busy={busy} label={t('creating')}>{t('enterToCreate')}</BusyLabel></span>
    </div>
  )
}
